import SectionHeaderV1 from "../../../../components/form_builder/elements/section_header/SectionHeaderV1.vue";

export default {
  componentName: "fb-section-header-v1",
  component: SectionHeaderV1,
  defaultAttrs: {
    properties: {
      value: `
        <p class="form-builder-section-header text-white bg-primary">
          Section Title
        </p>
      `,
      style: {},
      hidden: false,
      dependentProperties: {}
    }
  },
  gridAttrs: {
    type: "template",
    hidden: true,
    template: ({ value }) => value
  },
  validate: () => {
    return [];
  }
};
